import { generateAPI } from "../api.generator";

export type FeatureFlag = {
  key: string;
  name: string;
  description: string;
  enabled: boolean;
  rolloutMode: "all" | "selected";
  updatedAt?: string;
};

export const getFeatureFlags = generateAPI<object, FeatureFlag[]>(
  "get",
  "settings/feature-flags",
);
